import { connect } from "react-redux";
import moment from 'moment';
import { provideLocationState } from "components/utility/hoc/LocationState";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { Link } from "react-router-dom";

var ClassesDisplay = require("components/org/contests/ClassesDisplay");
var InviteTeachersModal = require("components/org/contests/InviteTeachersModal");
var ContestsRouting = require("lib/routing/ContestsRouting");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var ProgressBar = require("components/utility/ProgressBar");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ReactTooltip = require("react-tooltip");
var OrgDropdown = require("components/org/OrgDropdown");
var OwlShopRouting = require("lib/routing/OwlShopRouting");


var OrgTypes = require("lib/academic/OrgTypes");
var CurrentUser = require("lib/account/CurrentUser");
var StudentMetrics = require("lib/data/StudentMetrics");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var SchoolInfoModal = require("components/org/roster/SchoolInfoModal");
var OnboardingChecklist = require("components/users/teachers/onboarding/OnboardingChecklist");
var PhotosDisplay = require("components/social/photos/PhotosDisplay");

require("org/contests/contests_page.scss");

// Provide location state first, since we may want to access the school ID
@provideLocationState(ContestsRouting.getRouteState)
@connect(
	(state, props) => {
		var asDistrictAdmin = CurrentUser.isSignedIn() && CurrentUser.isDistrictAdmin();

		if (asDistrictAdmin) {

			var school = RosterSelectors.school({
				state, id: props.locationState.l2eSchoolID
			});

			if (school) {
				var selectedSchoolOrg = RosterSelectors.schoolOrgs({
					state, filters: { school_id: school.l2e_id }
				})

				if (selectedSchoolOrg) {
					var selectedSchoolOrgID = selectedSchoolOrg[0].id;
				}
			}

		} else {
			var school = RosterSelectors.primarySchool({ state });
		}
		if (school) {
			if (asDistrictAdmin) {
				var studentLists = RosterSelectors.studentLists({
					state, filters: { school_id: school.l2e_id }
				});
			} else {
				// No filter here will cause an issue if there's ever a time
				// Non district admins will want to swich between school pages
				var studentLists = RosterSelectors.studentLists({
					state
				});
			}
			studentLists = studentLists.filter(sl => sl.digest);
		}

		if (props.locationState.csSchoolID) {
			var loading = RosterSelectors.isLoadingSchool({
				state, key: props.locationState.csSchoolID
			})

		} else if (props.locationState.l2eSchoolID) {
			var loading = RosterSelectors.isLoadingSchool({
				state, key: props.locationState.l2eSchoolID
			})

		} else {
			var loading = false;
		}

		var showModal = CurrentUser.isSignedIn() && CurrentUser.isAdmin();
		var showEditPrompt = CurrentUser.isSignedIn() && CurrentUser.isAdmin();
		var asSchoolAdmin = CurrentUser.isSignedIn() && CurrentUser.isSchoolAdmin();

		return {
			school, studentLists, selectedSchoolOrgID,
			loading,
			showModal, showEditPrompt,
			asSchoolAdmin, asDistrictAdmin,

			getSchoolID: (schoolOrgID) => {
				return RosterSelectors.schoolOrg({ state, id: schoolOrgID }).school_id
			}
		};
	},

	(dispatch, props) => ({
		populateData: () => {
			if (props.locationState.csSchoolID) {
				var id = props.locationState.csSchoolID
				var query = {
					id_type: "cs_id"
				};

			} else if (props.locationState.l2eSchoolID) {
				var id = props.locationState.l2eSchoolID;
				var query = {
					id_type: "l2e_id"
				};

			} else if (CurrentUser.isSignedIn()) {
				var school = CurrentUser.get().school;
				if (school) {
					var query = {};
					if (school.canonical_id) {
						var id = school.canonical_id;
						query.id_type = "cs_id";
					} else {
						var id = school.l2e_id;
						query.id_type = "l2e_id";
					}
				}
			}

			if (query && id) {
				dispatch(RosterActions.fetchSchool({
					id, query,
					embeds: ["school.contests", "school.digest", "school.active_student_lists", "student_list.digest"]
				}))
			}
		}
	})
)

@providePopulateData()
class ContestsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("ContestsPage");
	}

	onViewChange(view) {
		this.changeView({ activeView: view });
	}
	openInviteModal() {
		this.changeView({ showInviteModal: true });
	}
	onInviteLinkClick() {
		$wr.redirect("/settings/referral")
	}
	hideInviteModal() {
		this.changeView({ showInviteModal: false });
	}
	openSchoolInfoModal() {
		this.changeView({ showSchoolInfoModal: true });
	}
	hideSchoolInfoModal() {
		this.changeView({ showSchoolInfoModal: false })
	}
	updateSchoolInfo() {
		this.props.populateData()
	}

	changeView(update) {
		var newLocationState = _.extend({}, this.props.locationState, update)

		$wr.redirect(ContestsRouting.getPath(newLocationState));
		setTimeout(() => {
			this.props.populateData();
		}, 10);
	}

	changeSubject(activeView, subjectType, subjectID) {
		$wr.redirect(ContestsRouting.getPath({
			activeView: this.props.locationState.activeView
		}));
	}

	onOrgSelect(orgIdentifier) {
		var schoolOrgID = parseInt(OrgTypes.fromIdentifier(orgIdentifier).key)
		var schoolID = this.props.getSchoolID(schoolOrgID);

		this.changeView({ l2eSchoolID: schoolID });
	}

	// invite link should only show when: 
	// 1. current user is not an admin is not a district/school admin
	// 2. current admin is on free product
	shouldInviteLinkShow() {
		if (this.props.asDistrictAdmin || this.props.asSchoolAdmin) { return false }

		var user = CurrentUser.get()
		return user.product == "wrSolo"
	}

	renderToggleControl() {
		var { activeView } = this.props.locationState;
		var toggleOptions = [
			{ key: ContestsRouting.VIEWS.READING, text: "Reading" },
			{ key: ContestsRouting.VIEWS.WRITING, text: "Writing" },
			{ key: ContestsRouting.VIEWS.OWLSTAGRAM, text: "Owlstagram" }
		];

		var toggleDisplay = (
			<DisplayToggleControl options={ toggleOptions }
				onChange={ this.onViewChange }
				activeOptionKey={ activeView } />
		);

		return toggleDisplay
	}


	renderHeader() {
		var school = this.props.school;
		var schoolName = school.name
		var startDate = school.contests[0].start_date;
		var endDate = school.contests[0].end_date;

		if (this.props.asDistrictAdmin) {
			if (school) {
				var orgIdentifier = OrgTypes.toIdentifier({
					type: OrgTypes.SCHOOL_ORG,
					key: this.props.selectedSchoolOrgID
				})
			}
			var orgDropdown = (
				<OrgDropdown dropdownDisplay="link"
					selectedIdentifier={ orgIdentifier }
					selectionTypes={ [OrgTypes.SCHOOL_ORG] }
					onSelect={ this.onOrgSelect } />
			);
		}

		if (this.props.showModal) {
			if (!(this.props.asSchoolAdmin || this.props.asDistrictAdmin)) {
				var changeSchoolLink = (
					<a className="changeSchoolLink" onClick={ this.openSchoolInfoModal }>Change School</a>
				);
			}
		}

		var firstOfMonth = moment().startOf("month").format("YYYY-MM-DD");
		var lastOfMonth = moment().endOf("month").format("YYYY-MM-DD");

		if (firstOfMonth == startDate && lastOfMonth == endDate) {
			var datesDisplay = (
				<span className="datesHeader">{ moment().format("MMMM YYYY") }</span>
			)
		} else {
			var datesDisplay = (
				<span className="datesHeader">{ moment(startDate).format("MMM Do, YYYY") } - { moment(endDate).format("MMM Do, YYYY") }</span>
			)
		}

		return (
			<header className="pageHeader">
				<h1>{ schoolName }</h1>
				{ changeSchoolLink }
				{ orgDropdown }
				{ datesDisplay }
			</header>
		)
	}

	renderSamplePhotos() {
		var img_paths = [require("empty-owlstagram/summer-owl.png"),
		require("empty-owlstagram/winter-owl.png"),
		require("empty-owlstagram/late-owl.png")]
		return (
			img_paths.map(path => {
				return (
					<div className="photoBox" key={ path }>
						<div className="clearfix textHeader">
							<div className="pull-left">
								Name
							</div>
							<div className="pull-right">
								Date
							</div>
						</div>
						<img className="photo samplePhoto" src={ path } />
					</div>
				)
			})
		)
	}

	renderOwlstagram() {
		var studentListIDs = _.pluck(this.props.studentLists, "id")
		return (
			<PhotosDisplay
			isClass = { false }
			ids = { studentListIDs }
			/>
		)

	}

	renderPageContent(activeView) {
		var school = this.props.school

		var studentLists = _.select(this.props.studentLists, (studentList) => {
			return studentList.digest.student_count > 0;
		});

		// Reading Variables
		var readingMetric = school.contests[0].reading_metric;
		var readingGoal = school.contests[0].reading_goal
		var readingValue = school.digest[readingMetric];

		var sortedReadingStudentLists = _.sortBy(studentLists, (sl) => sl["digest"][readingMetric]).reverse();
		var topReadingStudentLists = _.first(sortedReadingStudentLists, 3)

		var topReadingStudentListIDS = _.map(topReadingStudentLists, (sl) => {
			return sl.id;
		})
		var lowerReadingStudentLists = _.reject(sortedReadingStudentLists, (sl) => {
			return _.contains(topReadingStudentListIDS, sl.id);
		});

		// Writing Variables
		var writingMetric = school.contests[0].writing_metric;
		var writingGoal = school.contests[0].writing_goal
		var writingValue = school.digest[writingMetric];

		var sortedWritingStudentLists = _.sortBy(studentLists, (sl) => sl["digest"][writingMetric]).reverse();
		var topWritingStudentLists = _.first(sortedWritingStudentLists, 3)

		var topWritingStudentListIDS = _.map(topWritingStudentLists, (sl) => {
			return sl.id;
		})
		var lowerWritingStudentLists = _.reject(sortedWritingStudentLists, (sl) => {
			return _.contains(topWritingStudentListIDS, sl.id);
		});

		if (activeView == "reading") {
			var topClasses = topReadingStudentLists;
			var lowerClasses = lowerReadingStudentLists;
			var value = readingValue;
			var goal = readingGoal;
			var metric = readingMetric;
			var imgSrc = require("meters/progress-reading.png");
		} else {
			var topClasses = topWritingStudentLists;
			var lowerClasses = lowerWritingStudentLists;
			var value = writingValue;
			var goal = writingGoal;
			var metric = writingMetric;
			var imgSrc = require("meters/progress-writing.png");
		}

		var progress;
		progress = value / goal;
		progress = Math.min((progress || 0.0), 1.0);

		var percent = Math.round(progress * 100);

		if (percent >= 100) {
			var celebrationImgSrc = require("perks/backgrounds/confetti.png");
			var celebrationImage = (<img src={ imgSrc } alt="" />)
			var celebrationText = (
				<p className="statusText">Congratulations. Your goal has been reached!</p>
			)
			var celebrationStyle = { backgroundImage: "url(" + celebrationImgSrc + ")" };
			var statusContainer = (
				<div className="celebrationContainer">
					{ celebrationText }
					<div className="celebrationImage" style={ celebrationStyle }></div>
				</div>
			)
			var goalMet = "goalMet";
		} else if (percent == 0) {
			var statusContainer = (
				<div>
					<p className="statusText">It's time to get to work and make some progress on this goal!</p>
				</div>
			)
		}

		var meterStyle = { backgroundImage: "url(" + imgSrc + ")", width: (percent + "%") };

		var unitName = StudentMetrics.inverseLookup(metric);
		var adjustedUnitName = StudentMetrics.getUnit(unitName);

		if (unitName == "writing") {
			var unitTip = "Answers, Quizzes, Reviews, and Exercises";
			var tooltipIcon = (
				<span> <Glyphicon icon="question-sign" /></span>
			);
		}

		if (!value) {
			var numberValue = 0;
		} else {
			var numberValue = $wr.numberWithCommas(value);
		}

		var goalTracker = (
			<div className="meterSection">
				<div className="thermometerContainer">
					<div className="progressContainer" style={meterStyle}>
					</div>
				</div>
				<div className="trackerContainer">
					<p className="tracker">
						<span>Goal: </span>
						<span className="unitText">{ $wr.numberWithCommas(goal) } </span>
						<span data-tip={ unitTip }>
							{ adjustedUnitName }
							{ tooltipIcon }
						</span>
					</p>

					<p className="tracker">
						<span>So Far: </span>
						<span className={ "unitText " + goalMet }>{ numberValue } </span>
						<span className={ goalMet }>{ adjustedUnitName }</span>
					</p>
					<ReactTooltip effect="solid" />
				</div>
			</div>
		)

		if (studentLists.length) {
			var classesDisplay = (
				<div>
					<h3>Top Classes</h3>
					<ClassesDisplay classes={ topClasses } metric={ metric } showTopClasses={ true } />

					<div className="dividerArea"></div>

					<ClassesDisplay classes={ lowerClasses } metric={ metric } />
				</div>
			);
		}

		return (
			<div className="contestContainer readingContainer">
				{ statusContainer }
				{ goalTracker }
				{ classesDisplay }
			</div>
		);
	}


	render() {
		var school = this.props.school;

		var { activeView } = this.props.locationState;

		if (school == null) {
			if (this.props.asDistrictAdmin && !this.props.loading) {
				var school = this.props.school;

				if (school) {
					var orgIdentifier = OrgTypes.toIdentifier({
						type: OrgTypes.SCHOOL_ORG,
						key: this.props.selectedSchoolOrgID
					})
				}

				var orgDropdown = (
					<OrgDropdown dropdownDisplay="link"
						selectedIdentifier={ orgIdentifier }
						selectionTypes={ [OrgTypes.SCHOOL_ORG] }
						onSelect={ this.onOrgSelect } />
				);
				return (
					<div className="">
						<header className="pageHeader">
							<h1>School Page</h1>
							<p>
								Select a school:
							</p>
							{ orgDropdown }
						</header>
					</div>
				);
			} else {
				return (
					<div className="">
						<Spinner placeholder={true} scale={1.7} />
					</div>
				);
			}
		}

		if (activeView != "owlstagram") {
			var pageContent = this.renderPageContent(activeView)
		} else {
			var pageContent = this.renderOwlstagram()
		}

		if (this.props.showModal) {
			if (this.props.locationState.showInviteModal) {
				var inviteModal = <InviteTeachersModal onClose={this.hideInviteModal} />;
			} else if (this.props.locationState.showSchoolInfoModal) {
				var schoolInfoModal = (<SchoolInfoModal allowHide={true}
					onClose={this.hideSchoolInfoModal} updateSchoolInfo={this.updateSchoolInfo} />)
			}
			// Kevin 10/2021: the modal was not functional since the Cio campaign was turned off
			// Redirect users to the referral settings page instead
			if (this.shouldInviteLinkShow()) {
				var inviteTeachers = (
					<div className="inviteTeachersContainer">
						<span>Want more classes to participate?</span>
						<button className="buttonPrimary" onClick={this.onInviteLinkClick}>
							Invite Teachers
						</button>
						{ inviteModal }
					</div>
				);
			}
		}

		if (CurrentUser.isAdmin()) {
			var onboardingChecklist = <OnboardingChecklist />;
		}

		if (this.props.showEditPrompt && activeView != 'owlstagram') {
			var editInstructions = (
				<p>
					<br />Want to set this page to specific dates or make other customizations?
					{" "}<a href="https://whooosreading.zendesk.com/hc/en-us/articles/360038828332-Customize-your-School-Page"
						target="_blank">
						Learn how here.
					</a>
				</p>
			);
		}

		var toggleDisplay = this.renderToggleControl()
		var pageHeader = this.renderHeader()

		return (
			<div className="container contestsPage">
				{ onboardingChecklist }
				{ pageHeader }
				{ toggleDisplay }
				{ editInstructions }
				{ pageContent }
				{ inviteTeachers }
				{ schoolInfoModal }
			</div>
		);
	};
}

ContestsPage.WrappedComponent.propTypes = PageStrictPropTypes({
	locationState: PropTypes.object,

	// @connect data
	school: PropTypes.object,
	studentLists: PropTypes.array,
	showInvite: PropTypes.bool,
	asSchoolAdmin: PropTypes.bool,
	asDistrictAdmin: PropTypes.bool,
	showEditPrompt: PropTypes.bool,
	loading: PropTypes.bool,
	selectedSchoolOrgID: PropTypes.number,

	// @connect data fetchers
	getSchoolID: PropTypes.func,

	// @connect handlers
	populateData: PropTypes.func
});

module.exports = ContestsPage;


// WEBPACK FOOTER //
// ./modules/components/org/contests/ContestsPage.js